export const queryKeys = {
  favoriteGames: (username: string) => ['favoriteGames', username] as const,
  invitation_codes: ['invitation_codes'] as const,
  referral_statistics: ['referral_statistics'] as const,
  friends_list: ['friends_list'] as const,
  referral_bonus_records: ['referral_bonus_records'] as const,
  referral_rebates: ['referral_rebates'] as const,
  promotions: ['promotions'] as const,
  blogs: ['blogs'] as const,
  news: ['news'] as const,
  free_bonus_list: ['free_bonus_list'] as const,
  available_bonuses: ['available_bonuses'] as const,
  inbox_messages: ['inbox_messages'] as const,
  unread_messages: ['unread_messages'] as const,
  feedback_history: ['feedback_history'] as const,
  feedback_unread: ['feedback_unread'] as const,
  record_list: ['record_list'] as const,
  footer_links: ['footer_links'] as const,
  app_version: ['app_version'] as const,
  notices: ['notices'] as const,
  system_lists: ['system_lists'] as const,
  // New VIP system (VIP体系重构). Per-user scope; the username slot turns
  // login/logout into automatic cache invalidation. Served by useVipStatus /
  // useVipCheckPopup / useVipBonusRecords / useVipPendingBonuses /
  // useVipExperienceRecords against the real /vip.php endpoints.
  vipCenter: {
    // Root prefix — use to invalidate the whole vipCenter namespace.
    all: ['vipCenter'] as const,
    checkPopup: (username: string) =>
      ['vipCenter', 'checkPopup', username] as const,
    progress: (username: string) => ['vipCenter', 'progress', username] as const,
    experienceLog: (username: string, filter: string) =>
      ['vipCenter', 'experienceLog', username, filter] as const,
    bonusRecords: (username: string) =>
      ['vipCenter', 'bonusRecords', username] as const,
    pendingBonuses: (username: string) =>
      ['vipCenter', 'pendingBonuses', username] as const,
  },
}
